import { render } from "./g-login-recovery.vue?vue&type=template&id=930ffd22&ts=true"
import script from "./g-login-recovery.vue?vue&type=script&lang=tsx"
export * from "./g-login-recovery.vue?vue&type=script&lang=tsx"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__